import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import {AppletLabelLinkContainerModel} from "../../../../../../models/aggregates/applet/label";

@Injectable({providedIn: 'root'})

export class AppletLabelLinkService extends BaseApiTemplateService<AppletLabelLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-label-links';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-label-links';
    this.httpClient = http;
  }

}
